import React, { useContext, useEffect, useState } from "react";
import EventsFlow from "./EventsFlow";
import { AuthContext } from "../context";
import RequestService from "../api/RequestService";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Button, Icon } from "react-materialize";
import useConfirm from "../context/ConfirmDialog";

const Collection = () => {
  const { isFullScreenLoading, setFullScreenLoading } = useContext(AuthContext);
  const [collectionError, setCollectionError] = useState(null);
  const params = useParams();
  const [collectionData, setCollectionData] = useState(null);
  const confirm = useConfirm();
  const navigate = useNavigate();

  useEffect(() => {
    getCollection();
  }, []);

  const getCollection = async () => {
    setFullScreenLoading(true);
    const response = (await RequestService.getCollection(params.id)).data;
    setFullScreenLoading(false);
    // console.log(response);
    if (!response.response_code) {
      setCollectionError(response.message);
      return;
    }

    setCollectionData(response.result);
  };

  const deleteCollection = async () => {
    const choice = await confirm({
      description: "Вы действительно хотите удалить подборку?",
    });
    if (choice) {
      setFullScreenLoading(true);
      const response = (await RequestService.deleteCollection(params.id)).data;
      setFullScreenLoading(false);
      // console.log(response);
      if (!response.response_code) {
        await confirm({
          description: response.message,
          isAlert: true,
        });
        // alert(response.message);
        return;
      }

      await confirm({
        description: "Коллекция удалена",
        isAlert: true,
      });
      // alert("Проект удален");

      navigate("/profile");
    }
  };

  return (
    <div>
      {collectionData || collectionError ? (
        <EventsFlow
          header={collectionData ? collectionData.name : null}
          headerTruncate={false}
          customError={collectionError}
          hasFilterPanel={false}
          eventsFilterParams={collectionData ? collectionData.filter : ""}
          additionalContent={
            <div className="row nm">
              {collectionData && collectionData.description ? (
                <div className="col s12 secondary-color l300 mb25">
                  {collectionData.description}
                </div>
              ) : null}

              {collectionData && collectionData.is_owner == 1 ? (
                <div
                  className="col s12 secondary-color center-align mb25"
                  style={{
                    gap: "10px",
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Link to={"/collections/edit/" + params.id}>
                    <Button icon={<Icon left>edit</Icon>} className="iq-btn">
                      Редактировать подборку
                    </Button>
                  </Link>

                  <Button
                    icon={<Icon left>delete</Icon>}
                    className="iq-btn iq-btn-delete"
                    onClick={deleteCollection}
                  >
                    Удалить подборку
                  </Button>
                </div>
              ) : null}
            </div>
          }
        />
      ) : null}
    </div>
  );
};

export default Collection;
